module.exports = __webpack_public_path__ + "1f6a81b8066467e2bc3cd1e57133e2b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/bgr_8.jpg
// module id = 836
// module chunks = 0